<script setup lang="ts">
useDefaultMeta({
  title: 'Tentang PT. Selalu Siap Solusi',
  description:
    'KiriminAja adalah aggregator logistik/pengiriman untuk seller, pebisnis/perusahaan, supaya bisnis berkembang &amp; berkelanjutan. Kembangkan bisnismu sekarang!',
  robots: 'index, follow'
})
</script>
<template>
  <AboutHero />
  <AboutBenefit />
  <AboutPoint />
  <AboutDirector />
  <CtaSection />
</template>
